<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div class="crud-title">
              <translate>VIEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="elements[0].inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-pt-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'Generator',
  components: { JtDynamicForm },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class GeneratorDetailPage extends Vue {
  nmInterface = 'detalhar';
}

export default GeneratorDetailPage
</script>
<style lang="stylus" scoped></style>
